
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30447',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30447",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54824",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8111",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11566",
  "I18n": "static-7.1634",
  "quartz": "static-1.7142",
  "quartz-config": "static-1.920",
  "quartz-core": "static-1.6361",
  "react-dlb": "static-1.80",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.817",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54811",
  "feedback-utils": "static-1.54815",
  "forms-embed-utils-lib": "static-1.4557",
  "forms-utils-lib": "static-1.12750",
  "foundations-assets": "static-1.4961",
  "foundations-components": "static-1.8108",
  "foundations-theming": "static-1.4524",
  "hub-http": "static-1.6314",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11873",
  "icons": "static-2.651",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3985",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16774",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5411",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.489",
  "tinymce-plugins": "static-1.57725",
  "transmute": "static-2.85",
  "ui-images": "static-2.1175",
  "UIComponents": "static-3.8512",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3468",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3419",
  "quartz-webpack": "static-1.3366",
  "foundations-theming-specialty": "static-1.2240",
  "property-description-translator": "static-1.3932",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3222",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4418",
  "jasmine-runner": "static-1.6553",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4719",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.817",
  "quartz-head": "static-1.807",
  "quartz-i18n": "static-1.817",
  "quartz-routing": "static-1.572",
  "quartz-test": "static-1.817",
  "quartz-tracking": "static-1.521",
  "trellis-components": "static-1.2182",
  "ui-fonts": "static-1.828",
  "usage-tracker-container": "static-1.7431",
  "usage-tracker-core": "static-1.7291",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7343",
  "reference-resolvers": "static-1.8266",
  "sanitize-text": "static-1.8237",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10455",
  "sanitize": "static-1.4569",
  "outpost": "static-1.4263",
  "rpc-client-utils": "static-1.4749",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4377",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9514",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2163",
  "bend-plugin-foundations-theming": "static-1.3007",
  "foundations-theming-base": "static-1.3509",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.149",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9182",
  "atom": "static-1.5167",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7895",
  "ContentUtils": "static-1.68618",
  "data-token-picker": "static-1.16563",
  "file-manager-components": "static-1.23850",
  "FileManagerCore": "static-1.39349",
  "FileManagerLib": "static-1.39490",
  "frontend-preferences-client": "static-1.8019",
  "hub-http-contrib": "static-1.3134",
  "interframe": "static-3.4853",
  "layout-dnd-components": "static-1.12615",
  "layout-dnd-utils": "static-1.11590",
  "property-translator": "static-1.5488",
  "react-codemirror": "static-1.10720",
  "react-colorpicker": "static-2.10300",
  "reference-resolvers-lite": "static-1.8190",
  "rich-text-lib": "static-1.19982",
  "tinymce-data": "static-1.40696",
  "tinymce-themes": "static-1.56581",
  "ui-addon-emoji-picker": "static-1.9979",
  "ui-addon-sales-email": "static-1.5303",
  "ui-brand-identity-lib": "static-1.15600",
  "bender-build-tools": "static-1.3278",
  "hub-http-shared-msw-handlers": "static-1.10187",
  "hubspotter-http-shared-msw-handlers": "static-1.10185",
  "usage-tracker-session-replay": "static-1.5127",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1032",
  "tanstack-virtual": "static-1.31",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.159",
  "chirp-fetch": "static-1.1980",
  "chatspot-core": "static-1.21729",
  "copilot-toolkit": "static-1.11366",
  "customer-data-objects-ui-components": "static-1.13123",
  "data-fetching-client": "static-1.9755",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4853",
  "ui-addon-video-player": "static-1.8795",
  "ui-coaching-tips": "static-1.28815",
  "usage-tracker": "static-1.7441",
  "cms-field-types": "static-1.4905",
  "content-icons-ui": "static-1.2251",
  "integrations-lib": "static-1.16450",
  "customer-data-objects": "static-1.7771",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4745",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4246",
  "ui-addon-iframeable": "static-1.9155",
  "video-components-external": "static-1.11572",
  "video-data-lib": "static-1.35230",
  "audio-components": "static-1.6053",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29462",
  "FileManagerImages": "static-1.37001",
  "foundations-components-legacy": "static-1.1133",
  "html-to-image": "static-1.55",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.526",
  "ui-universal-auth": "static-1.9085",
  "urlinator": "static-1.4629",
  "video-components": "static-1.13574",
  "video-embed": "static-1.36064",
  "ts-schema": "static-1.4148",
  "ContentData": "static-1.68693",
  "layout-data-lib": "static-1.9915",
  "react-dnd-compat": "static-1.4706",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1634",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6982",
  "hs-promise-utils": "static-1.5683",
  "inbound-db-properties-service-client": "static-1.3913",
  "NamespacedHubStyle": "static-2.9126",
  "growth-onboarding-confetti": "static-1.3158",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11243",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1016",
  "magpie-lib": "static-1.5611",
  "magpie-types": "static-1.5071",
  "simple-logging-lib": "static-1.3143",
  "avatar-components": "static-1.2589",
  "customer-data-ui-utilities": "static-1.9918",
  "growth-onboarding-feedback-components": "static-1.6672",
  "flux-actions": "static-1.343",
  "hubspot-apollo-client": "static-1.4970",
  "integrations-error-boundary-lib": "static-1.13865",
  "integrations-tracking-lib": "static-1.5698",
  "laboratory-lib": "static-3.7248",
  "native-integrations-shared-strings": "static-1.7874",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10315",
  "unified-auth": "static-1.599",
  "navigation-messaging": "static-1.7570",
  "content-media-composition-data-lib": "static-1.12601",
  "content-media-compositions": "static-2.16608",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19080",
  "unified-auth-core-lib": "static-1.881",
  "social-insights-client-types": "static-1.22301",
  "advanced-menus-core": "static-1.15274",
  "advanced-menus-lib": "static-1.12190",
  "ExportDialog": "static-6.10473",
  "ui-memberships-settings-lib": "static-1.34292",
  "conditional-properties-service-client": "static-1.3865",
  "crm-pipelines-api-client-types": "static-1.4206",
  "fdsr-migration-layer": "static-1.101",
  "framework-builder-read-service-client": "static-1.4073",
  "framework-data-schema-quick-fetch": "static-1.6887",
  "inbound-db-meta-service-client": "static-1.3654",
  "multi-currency-client-types": "static-1.3758",
  "persist-promise": "static-1.3791",
  "foundations-components-test-utils": "static-1.5591",
  "breeze-engine-core": "static-1.294",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.819",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.429",
  "universal-page-editor-lib": "static-1.3109",
  "ads-unified-auth-lib": "static-1.286",
  "google-sheets-integration-lib": "static-1.506",
  "microsoft-drive-integration-lib": "static-1.644",
  "slack-ui-library": "static-1.10485",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3821",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15273",
  "simple-menus-lib": "static-1.16790",
  "crm-record-cards-service-types": "static-1.3658",
  "location-customization-utils-lib": "static-1.9526",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30447",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54824",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8111",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11566",
  "I18n": "/I18n/static-7.1634",
  "quartz": "/quartz/static-1.7142",
  "quartz-config": "/quartz-config/static-1.920",
  "quartz-core": "/quartz-core/static-1.6361",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.817",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54811",
  "feedback-utils": "/feedback-utils/static-1.54815",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4557",
  "forms-utils-lib": "/forms-utils-lib/static-1.12750",
  "foundations-assets": "/foundations-assets/static-1.4961",
  "foundations-components": "/foundations-components/static-1.8108",
  "foundations-theming": "/foundations-theming/static-1.4524",
  "hub-http": "/hub-http/static-1.6314",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11873",
  "icons": "/icons/static-2.651",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3985",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16774",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5411",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tinymce-plugins": "/tinymce-plugins/static-1.57725",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1175",
  "UIComponents": "/UIComponents/static-3.8512",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3468",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3419",
  "quartz-webpack": "/quartz-webpack/static-1.3366",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2240",
  "property-description-translator": "/property-description-translator/static-1.3932",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3222",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4418",
  "jasmine-runner": "/jasmine-runner/static-1.6553",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4719",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.817",
  "quartz-head": "/quartz-head/static-1.807",
  "quartz-i18n": "/quartz-i18n/static-1.817",
  "quartz-routing": "/quartz-routing/static-1.572",
  "quartz-test": "/quartz-test/static-1.817",
  "quartz-tracking": "/quartz-tracking/static-1.521",
  "trellis-components": "/trellis-components/static-1.2182",
  "ui-fonts": "/ui-fonts/static-1.828",
  "usage-tracker-container": "/usage-tracker-container/static-1.7431",
  "usage-tracker-core": "/usage-tracker-core/static-1.7291",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7343",
  "reference-resolvers": "/reference-resolvers/static-1.8266",
  "sanitize-text": "/sanitize-text/static-1.8237",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10455",
  "sanitize": "/sanitize/static-1.4569",
  "outpost": "/outpost/static-1.4263",
  "rpc-client-utils": "/rpc-client-utils/static-1.4749",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4377",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9514",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2163",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3007",
  "foundations-theming-base": "/foundations-theming-base/static-1.3509",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.149",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9182",
  "atom": "/atom/static-1.5167",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7895",
  "ContentUtils": "/ContentUtils/static-1.68618",
  "data-token-picker": "/data-token-picker/static-1.16563",
  "file-manager-components": "/file-manager-components/static-1.23850",
  "FileManagerCore": "/FileManagerCore/static-1.39349",
  "FileManagerLib": "/FileManagerLib/static-1.39490",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8019",
  "hub-http-contrib": "/hub-http-contrib/static-1.3134",
  "interframe": "/interframe/static-3.4853",
  "layout-dnd-components": "/layout-dnd-components/static-1.12615",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11590",
  "property-translator": "/property-translator/static-1.5488",
  "react-codemirror": "/react-codemirror/static-1.10720",
  "react-colorpicker": "/react-colorpicker/static-2.10300",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8190",
  "rich-text-lib": "/rich-text-lib/static-1.19982",
  "tinymce-data": "/tinymce-data/static-1.40696",
  "tinymce-themes": "/tinymce-themes/static-1.56581",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9979",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5303",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15600",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10187",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10185",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5127",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1032",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.159",
  "chirp-fetch": "/chirp-fetch/static-1.1980",
  "chatspot-core": "/chatspot-core/static-1.21729",
  "copilot-toolkit": "/copilot-toolkit/static-1.11366",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13123",
  "data-fetching-client": "/data-fetching-client/static-1.9755",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4853",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8795",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28815",
  "usage-tracker": "/usage-tracker/static-1.7441",
  "cms-field-types": "/cms-field-types/static-1.4905",
  "content-icons-ui": "/content-icons-ui/static-1.2251",
  "integrations-lib": "/integrations-lib/static-1.16450",
  "customer-data-objects": "/customer-data-objects/static-1.7771",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4745",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4246",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9155",
  "video-components-external": "/video-components-external/static-1.11572",
  "video-data-lib": "/video-data-lib/static-1.35230",
  "audio-components": "/audio-components/static-1.6053",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29462",
  "FileManagerImages": "/FileManagerImages/static-1.37001",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1133",
  "html-to-image": "/html-to-image/static-1.55",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.526",
  "ui-universal-auth": "/ui-universal-auth/static-1.9085",
  "urlinator": "/urlinator/static-1.4629",
  "video-components": "/video-components/static-1.13574",
  "video-embed": "/video-embed/static-1.36064",
  "ts-schema": "/ts-schema/static-1.4148",
  "ContentData": "/ContentData/static-1.68693",
  "layout-data-lib": "/layout-data-lib/static-1.9915",
  "react-dnd-compat": "/react-dnd-compat/static-1.4706",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1634",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6982",
  "hs-promise-utils": "/hs-promise-utils/static-1.5683",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3913",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9126",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3158",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11243",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1016",
  "magpie-lib": "/magpie-lib/static-1.5611",
  "magpie-types": "/magpie-types/static-1.5071",
  "simple-logging-lib": "/simple-logging-lib/static-1.3143",
  "avatar-components": "/avatar-components/static-1.2589",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9918",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6672",
  "flux-actions": "/flux-actions/static-1.343",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4970",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13865",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5698",
  "laboratory-lib": "/laboratory-lib/static-3.7248",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7874",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10315",
  "unified-auth": "/unified-auth/static-1.599",
  "navigation-messaging": "/navigation-messaging/static-1.7570",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12601",
  "content-media-compositions": "/content-media-compositions/static-2.16608",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19080",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.881",
  "social-insights-client-types": "/social-insights-client-types/static-1.22301",
  "advanced-menus-core": "/advanced-menus-core/static-1.15274",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12190",
  "ExportDialog": "/ExportDialog/static-6.10473",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34292",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3865",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4206",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.101",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4073",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6887",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3654",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3758",
  "persist-promise": "/persist-promise/static-1.3791",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5591",
  "breeze-engine-core": "/breeze-engine-core/static-1.294",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.819",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.429",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3109",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.286",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.506",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.644",
  "slack-ui-library": "/slack-ui-library/static-1.10485",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3821",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15273",
  "simple-menus-lib": "/simple-menus-lib/static-1.16790",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3658",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9526",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
